// extracted by mini-css-extract-plugin
export default {"root":"styles_root__8SLzv","rootInner":"styles_rootInner__9x4AV","parentsContent":"styles_parentsContent__jxReb","tablet":"styles_tablet__pECk0"};